import { CustomerLink } from "../components/recordLinks.jsx";
import { Metric, Panel, ResourceKeyValue, ResourceTable, StageChart, Topbar } from "../components/ui.jsx";

export function LifecycleView({ resources, customers, openCustomer, openCall, openVisit, openMessage, openOrder }) {
  const stages = resources.lifecycle?.stages ?? {};
  const hasQuickActions = Boolean(openCall || openVisit || openMessage || openOrder);
  return (
    <>
      <Topbar title="Customer Lifecycle" subtitle="Initial, active order engagement, withdrawing risk, transition visibility, and recovery focus." />
      <section className="metric-grid">
        <Metric label="Initial" value={stages.Initial ?? 0} />
        <Metric label="Initiated Order" value={stages["Initiated Order"] ?? 0} />
        <Metric label="Withdrawing" value={stages.Withdrawing ?? 0} />
        <Metric label="Recovery Candidates" value={resources.lifecycle?.recoveryCandidates?.length ?? 0} />
      </section>
      <section className="content-grid">
        <Panel title="Lifecycle Stage Report">
          <StageChart stageCounts={stages} stages={["Initial", "Initiated Order", "Withdrawing"]} />
        </Panel>
        <Panel title="Drop-off Reasons">
          <ResourceKeyValue data={resources.lifecycle?.withdrawingReasons ?? {}} />
        </Panel>
      </section>
      <section className="panel spaced">
        <h2>Lifecycle Customers</h2>
        <ResourceTable
          rows={customers}
          columns={[["name", "Customer", (value, row) => <CustomerLink customer={row} customers={customers} fallbackName={value} openCustomer={openCustomer} />], ["lifecycleStage", "Lifecycle"], ["lifecycleReason", "Reason"], ["status", "Lead Status"], ["followUpDate", "Follow-up"]]}
          action={hasQuickActions ? (customer) => (
            <div className="row-actions">
              {openCall ? (
                <button className="mini-btn" type="button" onClick={() => openCall(customer)}>
                  Call
                </button>
              ) : null}
              {openVisit ? (
                <button className="mini-btn" type="button" onClick={() => openVisit(customer)}>
                  Visit
                </button>
              ) : null}
              {openMessage ? (
                <button className="mini-btn" type="button" onClick={() => openMessage(customer, lifecycleMessageDraft(customer))}>
                  Message
                </button>
              ) : null}
              {openOrder ? (
                <button className="mini-btn" type="button" onClick={() => openOrder(customer, lifecycleOrderDraft(customer))}>
                  Order
                </button>
              ) : null}
            </div>
          ) : undefined}
        />
      </section>
    </>
  );
}

function lifecycleMessageDraft(customer) {
  const template = customer.lifecycleStage === "Withdrawing"
    ? "Retention"
    : customer.lifecycleStage === "Initiated Order"
      ? "Order update"
      : "Follow-up";
  const reason = customer.lifecycleReason ? ` about ${customer.lifecycleReason.toLowerCase()}` : "";
  return {
    channel: "WhatsApp",
    template,
    message: `Following up with ${customer.name}${reason}.`,
    consentRecorded: customer.consentOptIn !== false,
  };
}

function lifecycleOrderDraft() {
  return {
    quantity: 1,
    discount: 0,
    status: "Draft",
  };
}
